import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
// components
import BookADemoButton from '../../ui/BookADemoButton'
// views
import AnimatedContainer from '../../ui/AnimatedContainer/animatedContainer'
import {
  descriptionAnimation,
  titleAnimation,
  subtitleAnimation,
} from '../../../constants/animation'
// assets
import Glow from '../../glows'
import EnterpriseMap from '../../../assets/imgs/enterprise/enterprise.png'

const EnterpriseComponent = () => {
  return (
    <section className='overview-section enterprise-content'>
      <div className='box'>
        <Glow position='right' />

        <AnimatedContainer className='enterprise-grid-container'>
          <div>
            <motion.p
              className='overview-title enterprise-overview-title'
              variants={titleAnimation}
            >
              Unified Talent View. <br /> AI-powered recruitment, retention &
              upskilling.
            </motion.p>
            <motion.p
              className='enterprise-subtitle'
              variants={subtitleAnimation}
            >
              One system to unify all your workforce data and turn insight into
              action.
            </motion.p>
            <motion.p className='description' variants={descriptionAnimation}>
              Pod overlays your ATS, HRIS, CRM, and LMS systems to deliver a
              single, AI-powered view of your workforce. Recruit smarter with
              bias-free matching, retain talent longer with predictive insights,
              and upskill employees through seamless learning integrations. From
              external candidates to internal mobility, Pod helps enterprises
              plan, act, and grow with confidence.
            </motion.p>
            <div className='enterprise-button-container'>
              <BookADemoButton />
            </div>
          </div>
          <div className='img-container'>
            <img
              className='enterprise-image'
              src={EnterpriseMap}
              alt='Enterprise Presentation'
            />
          </div>
        </AnimatedContainer>
      </div>
    </section>
  )
}

export default EnterpriseComponent
